module.exports = __webpack_public_path__ + "static/media/s2-2.6c37aec1.png";